export const LANG_KEY = "lang"
export const KEYSTORE_KEY = "keystore"

export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID

export const isProduction = import.meta.env.MODE === "production"

export const allowConversationIds = ["97730387-57a9-41a9-ac98-87698f25357d"]

export const isProductionGuard = false

export const enabledReceiveMdt = true

export const XIN_PRICE = 200

export type BondRate = {
  id: string
  rate: number
} & (
  | {
      mdtSymbol: "MDTb" | "MDTe" | "MDTu"
      price: number
    }
  | {
      MDTbPrice: number
      MDTePrice: number
      price: undefined
      mdtSymbol: undefined
    }
)

export const ADMIN_IDS = [
  "b847a455-aa41-4f7d-8038-0aefbe40dcaa",
  "04379bf8-87fb-41c6-a247-ee19bf9cf4a3", // kelley
  "0cff62ca-f654-46af-a7fe-2c8089d6755d",
]

export const BOND_RATE_LIST: BondRate[] = [
  {
    id: isProduction
      ? // btc
        "c6d0c728-2624-429b-8e0d-d9d19b6592fa"
      : // cnb
        "965e5c6e-434c-3fa9-b780-c50f43cd955c",
    rate: 0.9,
    mdtSymbol: "MDTb",
    price: 26569,
  },
  {
    id: isProduction
      ? // eth
        "43d61dcd-e413-450d-80b8-101d5e903357"
      : // nxc
        "66152c0b-3355-38ef-9ec5-cae97e29472a",
    rate: 0.3,
    mdtSymbol: "MDTe",
    price: 1592,
  },
  {
    id: isProduction
      ? // usdt
        "4d8c508b-91c5-375b-92b0-ee702ed2dac5"
      : // gm
        "517d5fbb-ebba-3652-80f3-33934099cca7",
    rate: 0.1,
    mdtSymbol: "MDTu",
    price: 1,
  },
  {
    id: "f5ef6b5d-cc5a-3d90-b2c0-a2fd386e7a3c",
    // id: "965e5c6e-434c-3fa9-b780-c50f43cd955c",
    rate: 0.9271,
    MDTbPrice: 0.11258467,
    MDTePrice: 0.1114918,

    price: undefined,
    mdtSymbol: undefined,
  },
]

export const CHAINS = [
  {
    chain_id: "9c612618-ca59-4583-af34-be9482f5002d",
    icon_url: "https://images.mixin.one/96l-LTbahgBXnKfLRHtiQybyk9kpA-eVIMYnzs4twATFtIq3Ayvw5zRfhGrt5IOGqUxxJuFXINJMTNkRlWpnFVbsA4Ep6FAn0pWP=s128",
    name: "Akash",
    symbol: "AKT",
  },
  {
    chain_id: "706b6f84-3333-4e55-8e89-275e71ce9803",
    icon_url: "https://images.mixin.one/-oE4Jsi3aMIkxUPUsvDozyL8D0ccmPkggIdIDu1z8THDQyJcCIsbNwC4amFBiRlkQiLNNjiuMBsNw8sAnehTuI0=s128",
    name: "Algorand",
    symbol: "ALGO",
  },
  {
    chain_id: "d2c1c7e1-a1a9-4f88-b282-d93b0a08b42b",
    icon_url: "https://images.mixin.one/vL_RBptRmAqV9iEPkARWUhQP0WqI9jPBMLNyJezvspZ4hPD9hq5SBluUKMwd_iG8Hpn3cS6nJML2Ji50D0zCBRVXXzUeM5gXnimt4w=s128",
    name: "Aptos",
    symbol: "APT",
  },
  {
    chain_id: "882eb041-64ea-465f-a4da-817bd3020f52",
    icon_url: "https://images.mixin.one/MDStWtCYDjGvGeEZp70xJduXK2cAEkQD9HkY-qi7m7yM4OOjjQqr3dVDcmvo55QBz96FqgygDj4aAz7leP5fISk=s128",
    name: "Arweave",
    symbol: "AR",
  },
  {
    chain_id: "cbc77539-0a20-4666-8c8a-4ded62b36f0a",
    icon_url: "https://images.mixin.one/0XWvbsGDaeVcrILNgH0fYj55oa_4H4bTx_k1Nm35qSbx0VzuAPyoJm3ZFXD7jHH-OFyJDGPOWJo1dJ1B-YMt3823vVBsCgmctvo=s128",
    name: "Avalanche",
    symbol: "AVAX",
  },
  {
    chain_id: "17f78d7c-ed96-40ff-980c-5dc62fecbc85",
    icon_url: "https://images.mixin.one/HCjLu6VM0XA7ouRcZJGDTOzE7zoXaA8LgESw075VW5teZ27AGUgyGrc4jnzuK5LtgT5HJQDSNSOImnU3IcUsBLoF=s128",
    name: "BNB Beacon Chain",
    symbol: "BNB",
  },
  {
    chain_id: "1949e683-6a08-49e2-b087-d6b72398588f",
    icon_url: "https://images.mixin.one/1_44tuBHW1cFfsPnzmzQE8aULR438AT_fjqOsXJp1LEVPSDHox45dI0WGsnzgz9rDRYnA92sWMaMDGWt-oePEFV5qp8HrCFvd7I=s128",
    name: "BNB Smart Chain",
    symbol: "BNB",
  },
  {
    chain_id: "05891083-63d2-4f3d-bfbe-d14d7fb9b25a",
    icon_url: "https://images.mixin.one/vPCw4G1BhBWLzFSVt8jMJxq7LhQgVRbn_IbgJif9mixgLyJfBTlrc4TbELTThAwQCdVqikJQNDDQ84nQZLVf1yGm=s128",
    name: "BTS",
    symbol: "BTS",
  },
  {
    chain_id: "c6d0c728-2624-429b-8e0d-d9d19b6592fa",
    icon_url: "https://images.mixin.one/HvYGJsV5TGeZ-X9Ek3FEQohQZ3fE9LBEBGcOcn4c4BNHovP4fW4YB97Dg5LcXoQ1hUjMEgjbl1DPlKg1TW7kK6XP=s128",
    name: "Bitcoin",
    symbol: "BTC",
  },
  {
    chain_id: "fd11b6e3-0b87-41f1-a41f-f0e9b49e5bf0",
    icon_url: "https://images.mixin.one/tqt14x8iwkiCR_vIKIw6gAAVO8XpZH7ku7ZJYB5ArMRA6grN9M1oCI7kKt2QqBODJwr17sZxDCDTjXHOgIixzv6X=s128",
    name: "Bitcoin Cash",
    symbol: "BCH",
  },
  {
    chain_id: "574388fd-b93f-4034-a682-01c2bc095d17",
    icon_url: "https://images.mixin.one/1iUl5doLjMSv-ElcVCI4YgD1uIayDbZcQP0WjFEajoY1-qQZmVEl5GgUCtsp8CP0aj96a5Rwi-weQ5YA64lyQzU=s128",
    name: "Bitcoin SV",
    symbol: "BSV",
  },
  {
    chain_id: "71a0e8b5-a289-4845-b661-2b70ff9968aa",
    icon_url: "https://images.mixin.one/XX0uDzi6b76ZP2oend6OgCWBUc9QPp1rfoFOIRN40aogbpdT0jp_dV1jgzaCnShK5DD6ETL8xSIQMYOEXrJrvqElwfG-UZ65s35sdg=s128",
    name: "Bytom",
    symbol: "BTM",
  },
  {
    chain_id: "7397e9f1-4e42-4dc8-8a3b-171daaadd436",
    icon_url: "https://images.mixin.one/t-HH_7zAE5Y7OG9WgC1muIeFWJee4WypzbdJ5FjakEIivRYnSz89CBR4twXH-K_wFFodURRhYulVY-PrOO35ZoQ=s128",
    name: "Cosmos",
    symbol: "ATOM",
  },
  {
    chain_id: "6472e7e3-75fd-48b6-b1dc-28d294ee1476",
    icon_url: "https://images.mixin.one/UEGZCbh_zPbCrah2vhzNBATOBi_7XhgZLKNDe8U49ZxIEAtUC0SO-nvG0QnOMOBM0XrGv5Z5FskxhNfZVYMaGQjqcvUrzzB6JBkc=s128",
    name: "Dash",
    symbol: "DASH",
  },
  {
    chain_id: "8f5caf2a-283d-4c85-832a-91e83bbf290b",
    icon_url: "https://images.mixin.one/ATSnFPH9vp6WPJ-KB9h_2JT93519YUPBbbbgAbPJBStlF3tFkP70iiZqDGi8ha-LssoqHMdRItF2_Un4FbglYMI=s128",
    name: "Decred",
    symbol: "DCR",
  },
  {
    chain_id: "6770a1e5-6086-44d5-b60f-545f9d9e8ffd",
    icon_url: "https://images.mixin.one/gtz8ocdxuC4N2rgEDKGc4Q6sZzWWCIGDWYBT6mHmtRubLqpE-xafvlABX6cvZ74VXL4HjyIocnX-H_Vxrz3En9tMcIKED0c-2MhH=s128",
    name: "Dogecoin",
    symbol: "DOGE",
  },
  {
    chain_id: "6cfe566e-4aad-470b-8c9a-2fd35b49c68d",
    icon_url: "https://images.mixin.one/OTwqLjEwc6v0JutJc-1sYkh_juFOvVbFz26WvvwfLGdKq6ZtwAT-wKhX0k-5PsgOK_Pd9rCQjZfwMJmiNXCBzpHnjapBtkCqAVCTCg=s128",
    name: "EOS",
    symbol: "EOS",
  },
  {
    chain_id: "43d61dcd-e413-450d-80b8-101d5e903357",
    icon_url: "https://images.mixin.one/zVDjOxNTQvVsA8h2B4ZVxuHoCF3DJszufYKWpd9duXUSbSapoZadC7_13cnWBqg0EmwmRcKGbJaUpA8wFfpgZA=s128",
    name: "Ethereum",
    symbol: "ETH",
  },
  {
    chain_id: "2204c1ee-0ea2-4add-bb9a-b3719cfff93a",
    icon_url: "https://images.mixin.one/fM9wgyNyB3Uiopx2FRFxhr-sYrvXZtJ-uCpk975wGdpoehoA59rIU-BQ4s_6YFMDEthQ74KCPysOIWSFK4vUG_Y=s128",
    name: "Ethereum Classic",
    symbol: "ETC",
  },
  {
    chain_id: "08285081-e1d8-4be6-9edc-e203afa932da",
    icon_url: "https://images.mixin.one/tS53GsHItszDc8OTpREDTL1mGdUlL-oJrt0unKEPxeb35Y7V7XtdmSd9dq0rgghyrfT_KllP5w_31bwDIRsuaQg=s128",
    name: "Filecoin",
    symbol: "FIL",
  },
  {
    chain_id: "1351e6bd-66cf-40c1-8105-8a8fe518a222",
    icon_url: "https://images.mixin.one/0rUV7Qlq3BkRbjf9DL1gt0f2cH92-oeDmnr2SL2MBe6h0WLDqX6krEKR-IXGC6O2y2CLwyYcikLbUVc_GbwUgz4=s128",
    name: "Grin",
    symbol: "GRIN",
  },
  {
    chain_id: "13036886-6b83-4ced-8d44-9f69151587bf",
    icon_url: "https://images.mixin.one/VvNrYJDwMh4HbKmnSQrzFvJbNd3pRtP1N-4cXFi09BluI2BMUAmxHsoXXXRO7y4q9cqs5qAXz-XondTANQgklzKu=s128",
    name: "Handshake",
    symbol: "HNS",
  },
  {
    chain_id: "a2c5d22b-62a2-4c13-b3f0-013290dbac60",
    icon_url: "https://images.mixin.one/CFQzgS3lZztswzt8mKVWAOWAJDhlQQw2gQZN4_-2bRAzRivObDq-KOdjGIv_vcY6FGJLFlFxN4vSrFb7t0uxsQ=s128",
    name: "Horizen",
    symbol: "ZEN",
  },
  {
    chain_id: "9d29e4f6-d67c-4c4b-9525-604b04afbe9f",
    icon_url: "https://images.mixin.one/PfvTs8aqyffhTwGwQhmJ6QbGgZwWsdvP3j4B-y_6b1ANjjtdzymM6HjK2g2RDRmikuF6pMSgL0t2ItBqrsW64QfJ=s128",
    name: "Kusama",
    symbol: "KSM",
  },
  {
    chain_id: "76c802a2-7c88-447f-a93e-c29c9e5dd9c8",
    icon_url: "https://images.mixin.one/dLK5T9I4YFA094o6nn-qZ_TWLUtIrL0xtjxOyURaLoPcl94m0JKQhXQiOrC775LS9d8apDfLXVfbpDzGmWDf0CWJ=s128",
    name: "Litecoin",
    symbol: "LTC",
  },
  {
    chain_id: "a0ffd769-5850-4b48-9651-d2ae44a3e64d",
    icon_url: "https://images.mixin.one/VCFf3_JslcMwo1SZx0LCGwHDn7drFYto29i4YAY6OOguAMedESjGOZUIloMiZhme5berYdVXqcKNw9rRzcNRRFt1BP4pREfDTXacDQ=s128",
    name: "Mixin Virtual Machine",
    symbol: "ETH",
  },
  {
    chain_id: "eea900a8-b327-488c-8d8d-1428702fe240",
    icon_url: "https://images.mixin.one/eckqDQi50ZUCoye5mR7y6BvlbXX6CBzkP89BfGNNH6TMNuyXYcCUd7knuIDpV_0W7nT1q3Oo9ooVnMDGjl8-oiENuA5UVREheUu2=s128",
    name: "MobileCoin",
    symbol: "MOB",
  },
  {
    chain_id: "05c5ac01-31f9-4a69-aa8a-ab796de1d041",
    icon_url: "https://images.mixin.one/sdlLs6NIN7Qd_fM3z4k-s4GtamiHo4pafLve7P7hnHaLEPs2ld0FSscEzqjdytGY2q8e-AyfCNVfqXbXYYqb8cwUf-X3oI2jRTZN=s128",
    name: "Monero",
    symbol: "XMR",
  },
  {
    chain_id: "d6ac94f7-c932-4e11-97dd-617867f0669e",
    icon_url: "https://images.mixin.one/0nSi93kH8io-seyMPFcDrmqH1P-tcGfW7DPdGBJ-GCPPrb-pHFO6bguU-wU1N62FkrWXJYL8hS47L5agAS0zJVpv1wf89-f-EBs=s128",
    name: "NEAR",
    symbol: "NEAR",
  },
  {
    chain_id: "27921032-f73e-434e-955f-43d55672ee31",
    icon_url: "https://images.mixin.one/I9f9bWw457YiAGMxyrNtu4aCezzgnnIYuxnNBzkN3aGG32HeOzFl-nA4miBRnU-3qnNylyiDZqoS-JfzfstnuQ=s128",
    name: "NEM",
    symbol: "XEM",
  },
  {
    chain_id: "f8b77dc0-46fd-4ea1-9821-587342475869",
    icon_url: "https://images.mixin.one/UtlEMoi7t6Q9p99oJ2KNLnMjajCrxdPanUJVw7_Emq4_G7fGsFhyWBQljFTrCFe-STHq3fsyt1asO78AtrD2ci4=s128",
    name: "Namecoin",
    symbol: "NMC",
  },
  {
    chain_id: "d243386e-6d84-42e6-be03-175be17bf275",
    icon_url: "https://images.mixin.one/kXBeculJqfAx4P6g0iOhEmtk_W9qAw5aeGDY-VWVxFauxEwSuY0DPYA09LijapPY5CgbTKMw8NBBvuZ3Fy2aUBUrBeA63aTo4nJ-Bw=s128",
    name: "Nervos",
    symbol: "CKB",
  },
  {
    chain_id: "54c61a72-b982-4034-a556-0d99e3c21e39",
    icon_url: "https://images.mixin.one/AeLhCJ6iDloyDS50ce8OgfK-0y5ExO-1rSeBSSRxMDQNuznc-rT3Hc07DiqD44G34QQYQwmctvIxpEbLhB7KDsQ7=s128",
    name: "Polkadot",
    symbol: "DOT",
  },
  {
    chain_id: "b7938396-3f94-4e0a-9179-d3440718156f",
    icon_url: "https://images.mixin.one/xFl-wIKkfzrKDnJMX1PjvcXyKYrW88yLvtiEHdudNkPnSZmY9CzibAlNp3C_wM6LFP9UzsBX-YlVNW_zoUNPWO5cowzT0Us48BOE=s128",
    name: "Polygon",
    symbol: "MATIC",
  },
  {
    chain_id: "6877d485-6b64-4225-8d7e-7333393cb243",
    icon_url: "https://images.mixin.one/qC2t9WkMv8f3O4LolVvaXKP9cuHXklYW-3bSu4Cl3WSRHkAkIGdQlBH4qqluZxqy7lnyuP9ffIVGXMNKTFF2AFQY=s128",
    name: "Ravencoin",
    symbol: "RVN",
  },
  {
    chain_id: "23dfb5a5-5d7b-48b6-905f-3970e3176e27",
    icon_url: "https://images.mixin.one/SyX2tH2mBbSc45IfkOysbbd8WtPEjla5R3xT9ym0tbKv_vAyzl_Jd5qEYsOhKyuFRv09w3uB4Vzs2XJuJzZeO7e_=s128",
    name: "Ripple",
    symbol: "XRP",
  },
  {
    chain_id: "990c4c29-57e9-48f6-9819-7d986ea44985",
    icon_url: "https://images.mixin.one/K1qFRFwAn2aJ-SEM4Tya7y_HBelBZsL5J1WEdZX4S3-APXHExcsZUYdyQAMRhgebcto3CF_OLoImx8U9-4-M7C4=s128",
    name: "Siacoin",
    symbol: "SC",
  },
  {
    chain_id: "64692c23-8971-4cf4-84a7-4dd1271dd887",
    icon_url: "https://images.mixin.one/eTzm8_cWke8NqJ3zbQcx7RkvbcTytD_NgBpdwIAgKJRpOoo0S0AQ3IQ-YeBJgUKmpsMPUHcZFzfuWowv3801cF5HXfya5MQ9fTA9HQ=s128",
    name: "Solana",
    symbol: "SOL",
  },
  {
    chain_id: "c99a3779-93df-404d-945d-eddc440aa0b2",
    icon_url: "https://images.mixin.one/JQLe3hGUmnLVoxYjd0Cs3qz8v16pbZxJ-agzzxhBAmhYcPk24p9WJ4OIXpdaVyTE4IPQW8YYJoszORwJx5E2HK4Oa3qtiXyiOiM=s128",
    name: "Starcoin",
    symbol: "STC",
  },
  {
    chain_id: "56e63c06-b506-4ec5-885a-4a5ac17b83c1",
    icon_url: "https://images.mixin.one/ViaQAx1SjMrLNWwncMfOHYzB4uaWXusmvZ1OErxwf4kME6kkadICrxnXBvavw94ZEn_fa-lfDAR1g9Jb6J9PqaJ4cDPp4A8CW18=s128",
    name: "Stellar",
    symbol: "XLM",
  },
  {
    chain_id: "ef660437-d915-4e27-ad3f-632bfb6ba0ee",
    icon_url: "https://images.mixin.one/T0pGzs4lg7sIKIEIb1diV_8kbrG5R96dOQD7ukTwBmSxE_xwYayRihxQ2but5Ed3zOor9zcQ5Qq4bpyzVaj6FPxymRSc7fjC_l_E=s128",
    name: "TON",
    symbol: "TON",
  },
  {
    chain_id: "25dabac5-056a-48ff-b9f9-f67395dc407c",
    icon_url: "https://images.mixin.one/SXfRh0WJZpHrDAbBItuwwLp_TPML7hrbAPHGIz_EQRga0fFm5yGtNd55_W0ZZv9HRj_6W6kE4O4tq8W78mutAPE=s128",
    name: "TRON",
    symbol: "TRX",
  },
  {
    chain_id: "5649ca42-eb5f-4c0e-ae28-d9a4e77eded3",
    icon_url: "https://images.mixin.one/5st3i_y2vTKd6HAbxSKk9HtC68oj_m5BowKpXNzzgjiSnYQRLfF14pFS_4pMCNQVjjQyA6EO6E5Gn_BhyGv02OA=s128",
    name: "Tezos",
    symbol: "XTZ",
  },
  {
    chain_id: "c3b9153a-7fab-4138-a3a4-99849cadc073",
    icon_url: "https://images.mixin.one/OzfqNm0HPcHmqQOlkGGU5GoaAI3EznfbALmDBOZJdl2lDhlkNMVFDIC_CUsaeHEfyIeYT7A6vNLSR-MyqpnaBlY=s128",
    name: "VCash",
    symbol: "VCASH",
  },
  {
    chain_id: "b12bb04a-1cea-401c-a086-0be61f544889",
    icon_url: "https://images.mixin.one/M_P4l_lJtQj39Nq0sSprAv69Qt9EsXNyMHMSfb58RMiEVLX77DAe2UtZPjLQr5b-dugJUf_lK8rtPjnBHUp_zCU2Z5CeOgNz0A69=s128",
    name: "XDC Network",
    symbol: "XDC",
  },
  {
    chain_id: "c996abc9-d94e-4494-b1cf-2a3fd3ac5714",
    icon_url: "https://images.mixin.one/9QWOYgcD0H7q1cH6PaSM08FQ549epnEzqIQ2EgEfK2s82jhsIu1wDKmsR7rkPFwjIYKOILteq7mW1hIaXcy4DhI=s128",
    name: "Zcash",
    symbol: "ZEC",
  },
]
